import React, { useCallback, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../store/app-context";
import AuthContext from "../../store/auth-context";

import styles from "./QuoteSubmitConfirmation.module.css"
import RFQHome from "../RFQ/RFQHome";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';
import RFQHomeSelector from "../RFQ/RFQHomeSelector";

const QuoteSubmitConfirmation = (props) => {
  const appCtx = useContext(AppContext);
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const userEmail = authCtx?.sessionUser?.emailId ?? '';

  let submittedWebRef = location?.state?.submittedWebRef;
  let quote = location?.state?.quote;
  
  // Adobe Analytics: userView and pageView
  const SetAnalytics = useCallback(()=>{SetAnalyticsData()},[]);

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    // Adobe Analytics: quoteFormSubmit
    window.digitalData = window.digitalData || []
    window.digitalData.push({
      event: 'quoteFormSubmit',
      quote: {
        id: quote.webReference,
        product: productsData,
        price : {currency: quote.currencyCode}
      },
    })  
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'quoteFormSubmit'
     });    
    //console.log('adobe - quoteFormSubmit', window.digitalData);    
  }, [SetAnalytics]);

  if (submittedWebRef) {
    sessionStorage.setItem("submittedWebRef", JSON.stringify(submittedWebRef));
  }
  if (!submittedWebRef && sessionStorage.getItem("submittedWebRef")) {
    submittedWebRef = JSON.parse(sessionStorage.getItem("submittedWebRef"));
  }
console.log("submittedWebRef",submittedWebRef)
  if (!submittedWebRef) {
    console.log("comes inside?")
    const navigateURL = "/quote-app";
    //window.location.href = navigateURL;
    window.location.href = navigateURL;
    return <RFQHomeSelector/>
  }

  //sessionStorage.removeItem("webReference");
  //sessionStorage.removeItem("acctInfo");
  //sessionStorage.removeItem("quote");

  const myBioRadLink =
    "/" +
    appCtx.lang.toLowerCase() +
    "-" +
    appCtx.country.toLowerCase() +
    "/my-bio-rad";

  let label_thankYou = "Thank you for your quote request.";
  let label_quoteSubmitted = "Your quote has been submitted,";
  let label_referenceNumber = "Reference number";
  let label_referenceNumberLSG = "Reference number(LSG)";
  let label_referenceNumberCDG = "Reference number(CDG)";
  let label_instructions =
    "To review your quote request, click the request number above or see the Quote Request History section on your My Bio-Rad page at any time.";
  let label_myBioRad = "My Bio-Rad";
  let label_confirmationEmailMsg =
    "A confirmation email with your quote request details will be sent to";

  if (appCtx && appCtx.bioradResources) {
    label_thankYou = appCtx.bioradResources.Thank_You_Quote_Request
      ? appCtx.bioradResources.Thank_You_Quote_Request
      : "Thank you for your quote request.";
    label_quoteSubmitted = appCtx.bioradResources.Quote_Submitted
      ? appCtx.bioradResources.Quote_Submitted
      : "Your quote has been submitted,";
    label_referenceNumber = appCtx.bioradResources.Reference_Number
      ? appCtx.bioradResources.Reference_Number
      : "Reference number";
    label_referenceNumberLSG = appCtx.bioradResources.Reference_Number_LSG
      ? appCtx.bioradResources.Reference_Number_LSG
      : "Reference number(LSG)";
    label_referenceNumberCDG = appCtx.bioradResources.Reference_Number_CDG
      ? appCtx.bioradResources.Reference_Number_CDG
      : "Reference number(CDG)";
    label_confirmationEmailMsg = appCtx.bioradResources.Confirmation_Email_SentTo
      ? appCtx.bioradResources.Confirmation_Email_SentTo
      : "A confirmation email with your quote request details will be sent to";
    label_instructions = appCtx.bioradResources.For_Details_Quote
    ? appCtx.bioradResources.For_Details_Quote
    : "To review your quote request, click the request number above or see the Quote Request History section on your My Bio-Rad page at any time.";
    label_myBioRad = appCtx.bioradResources.My_Bio_Rad
      ? appCtx.bioradResources.My_Bio_Rad
      : "My Bio-Rad";
  }

  const lsgQuoteDetailLink =
    submittedWebRef && submittedWebRef.LSG
      ? "/quotes/" + submittedWebRef.LSG
      : "/";
  const cdgQuoteDetailLink =
    submittedWebRef && submittedWebRef.CDG
      ? "/quotes/" + submittedWebRef.CDG
      : null;

  if (cdgQuoteDetailLink) {
    label_referenceNumber = label_referenceNumberLSG;
  }
  
  // Generate products data for quoteFormSubmit event.
  const productsData = quote.quoteLineEntityList.map(item => {
    const container = {};
    container.productInfo = {productID : item.skuNumber};
    container.quantity = item.quantity;
    if (item && item.formattedExtendedPrice === 'Inquire') {
      container.price = {viewedPrice : 'Inquire'};
    }
    else {
      if (quote && quote.isQuotedPrice) {
        container.price = {viewedPrice : item.unitQuotedPrice * item.quantity};
      }
      else if (quote && quote.isAccountPrice) {
        container.price = {viewedPrice : item.unitAccountPrice * item.quantity};
      }
      else {
        container.price = {viewedPrice : item.unitListPrice * item.quantity};
      }
    }
    
    return container;
  });

  return (
    <div className={styles.confirmMessage}>
      {/*<h1>Quote Confirmation</h1>*/}
      <div className={styles.actualMessage}>
        <p className={styles.tyyo}>
          <strong>{label_thankYou}</strong>
        </p>
        <p>{label_quoteSubmitted}</p>
        {lsgQuoteDetailLink && <p>
          <strong>
            {label_referenceNumber}:{" "}
            <Link to={lsgQuoteDetailLink} className={styles.btnlinkU}>
              <span className={styles.refNumber}>{submittedWebRef.LSG}</span>
            </Link>
          </strong>
        </p>}
        {cdgQuoteDetailLink && (
          <p>
            <strong>
              {label_referenceNumberCDG}:{" "}
              <Link to={cdgQuoteDetailLink} className={styles.btnlinkU}>
                <span className={styles.refNumber}>{submittedWebRef.CDG}</span>
              </Link>
            </strong>
          </p>
        )}
        <div>
            <div>
              <p>
                {label_confirmationEmailMsg}&nbsp;<a className={styles.btnlinkU} href={'mailto:' + userEmail}>{userEmail}</a>.
              </p>
            </div>
            <div>
              <p>
                {label_instructions}
              </p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteSubmitConfirmation;